










import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'TitleModel',
  props: {
    titleData: {
      type: Object,
      defalut: {}
    },
    clickMore: {
      type: Object,
      defalut: () => {}
    },
  },
  components: {
  },
  setup(props: any, { emit }: any) {
    const checkMore = () => {
      emit('clickMore', props.titleData.urlPath);
    };
    return {
      checkMore
    };
  },
});
